type Attributes = Record<string, string>;
type Callback = () => void;

export default function loadScript(
  url: string,
  id: string,
  attributesIn: Attributes,
  callbackIn: Callback
): boolean;
export default function loadScript(
  url: string,
  id: string,
  attributesIn: Attributes | Callback,
  callbackIn: never
): boolean;
export default function loadScript(
  url: string,
  id: string,
  attributesIn: Attributes | Callback,
  callbackIn?: Callback
) {
  let attributes: Attributes, callback: Callback | undefined;

  if (!callbackIn && typeof attributesIn === 'function') {
    callback = attributesIn;
    attributes = {};
  } else if (!callbackIn && typeof attributesIn === 'undefined') {
    attributes = {};
  } else {
    attributes = attributesIn as Attributes;
    callback = callbackIn as Callback;
  }

  if (id && document.getElementById(id)) {
    if (callback) {
      callback();
    }
    return false;
  }

  const first = document.getElementsByTagName('script')[0];
  if (!first?.parentNode) {
    return false;
  }

  const entry = document.createElement('script');
  entry.type = 'text/javascript';
  entry.async = true;
  if (callback) {
    entry.onload = callback;
  }
  entry.src = url;
  entry.id = id;

  Object.keys(attributes).forEach((name) => {
    const value = attributes[name];
    entry.setAttribute(name, value);
  });

  first.parentNode.insertBefore(entry, first);
  return true;
}
